import axios from 'axios';
import { getChannelToken_v1 } from 'js/library/utils/API/getChannelToken_v1';
import cfac22 from '../cfac22';

export function updatePendingUsersOrgs(action, uId, orgID) {
  return new Promise((resolve, reject) => {
    getChannelToken_v1(uId)
      .then((result) => {
        //console.log('RESULTADO GET CHANNEL TOKEN ===>', result);
        axios
          .post(
            cfac22('API_HOST_V1') + 'updatePendingUsersOrgs',
            {
              triiboHeader: {
                apiToken: cfac22('apiToken'),
                channelGroup: cfac22('channelGroup'),
                channelName: cfac22('channelName'),
                uId: uId,
                channelTokenId: result,
                channelId: cfac22('channelId'),
                sessionId: '001',
                transactionId: '002',
              },
              action,
              uId,
              orgID,
            },
            {
              headers: {
                'Full-Url': window.location.href,
              },
            }
          )
          .then((result) => {
            //console.log('RESULTADO UPDATE PENDING USER ORGS ===>', result);
            resolve(result.data);
          })
          .catch((error) => {
            //console.log('ERROR UPDATE PENDING USER ORGS ---->', error);
            reject(error);
          });
      })
      .catch((error) => {
        //console.log('ERROR UPDATE PENDING CHANNEL TOKEN ---->', error);
        reject(error);
      });
  });
}
